import React, { Component } from 'react';
import axios from "axios";
import {NotificationContainer} from 'react-notifications';

import { Link } from 'react-router-dom';
import AccountMenu from './AccountMenu';

import AddressNew from './AddressNew';
import AddressList from './AddressList';

class Address extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addressList:[],
            showNewAddressBox:false,
            editingAddress:null,
            serviceCheck:false,
        }   
        this.showNewAddressBox = this.showNewAddressBox.bind(this);
        this.handleEditAddress = this.handleEditAddress.bind(this);
        this.refreshAddresses = this.refreshAddresses.bind(this);
    }

    componentDidMount() {
        this.refreshAddresses();
    }

    async refreshAddresses() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/addressList', params);
            let resVal = response.data;
            if (resVal.status === 'success') {
                this.setState({ addressList: resVal.data || [], serviceCheck: true });
            } else {
                this.setState({ serviceCheck: true });
            }
        } catch (error) {
            console.error(error);
            this.setState({ serviceCheck: true });
        }
    }

    showNewAddressBox(passVal){
        this.setState({showNewAddressBox:passVal});
        if(passVal===false){
            this.setState({editingAddress:null});
        }
    }

    handleEditAddress(address){
        this.setState({
            editingAddress: address,
            showNewAddressBox: true,
        });
    }

    loadAddNewAddress(){
        if(this.state.showNewAddressBox==true){
            return(
                    <AddressNew
                        key={this.state.editingAddress ? this.state.editingAddress.address_id : 'new-address'}
                        showNewAddressBox={this.showNewAddressBox}
                        onSaved={this.refreshAddresses}
                        initialAddress={this.state.editingAddress}
                    />
            )
        }else{
            return(
                    <div className="ps-address__ctaWrap">
                        <p className="ps-address__ctaText">Add a delivery address so checkout stays quick and easy next time.</p>
                        <button
                            type="button"
                            className="ps-address__addButton"
                            onClick={() => this.setState({ editingAddress: null }, () => this.showNewAddressBox(true))}
                        >
                            Add new address
                        </button>
                    </div>
                )
        }
    }

    render() {
        return (
            <div className="ps-account-page ps-account-page--profile">
                <div className="ps-categogy ps-categogy--separate ps-account-shell">
                    <div className="container whiteContainer ps-account-shell__container">
                        <div className="ps-account-shell__layout">
                            <AccountMenu {...this.props}/>

                            <main className="ps-account-shell__content">
                                <div className="ps-account-shell__topbar">
                                    <ul className="ps-breadcrumb ps-account-shell__breadcrumb">
                                        <li className="ps-breadcrumb__item"><Link to="/">Account settings</Link></li>
                                        <li className="ps-breadcrumb__item active" aria-current="page">Manage addresses</li>
                                    </ul>
                                    <div className="ps-account-shell__eyebrow">Saved places</div>
                                </div>

                                <section className="ps-account-shell__hero">
                                    <div className="ps-account-shell__heroCopy">
                                        <span className="ps-account-shell__label">Your delivery book</span>
                                        <h1>Keep your addresses organized</h1>
                                        <p>Add, update, and manage your shipping addresses from one clean view so checkout stays fast and easy.</p>
                                    </div>
                                </section>

                                <section className="ps-account-shell__panel">
                                    <div className="ps-account-shell__card">
                                        <div className="ps-account-shell__cardHeader">
                                            <span className="ps-account-shell__panelLabel">Address form</span>
                                            <h2>{this.state.editingAddress ? 'Edit address' : 'Add a new address'}</h2>
                                        </div>

                                        {this.loadAddNewAddress()}
                                    </div>
                                </section>

                                <section className="ps-account-shell__panel">
                                    <div className="ps-account-shell__card">
                                        <div className="ps-account-shell__cardHeader">
                                            <span className="ps-account-shell__panelLabel">Saved addresses</span>
                                            <h2>Manage delivery locations</h2>
                                        </div>

                                        <AddressList
                                            addressList={this.state.addressList}
                                            onEditAddress={this.handleEditAddress}
                                        />
                                    </div>
                                </section>
                            </main>
                        </div>
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        );
    }
}

export default Address;
